import React, { Component } from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap'
import Modal from 'react-modal'
import { Helmet } from "react-helmet"
import { Link } from 'react-router-dom'
import './index.css'

import Postman from '../../utils/service'
import { isEmpty } from '../../common/utils'
import { connect } from 'react-redux'
import { SET_IS_FILTER_OPENED, SET_FILTER } from '../../actions/actiontypes'
import AppContext from '../../AppContext'
import { encodeforspace } from '../../utils/helper'
import Cookies from 'js-cookie';
import LazyLoad from 'react-lazyload';
import ReactHtmlParser from 'react-html-parser';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '350px',
    height: '200px',
    border: 0,
    padding: 33,
    borderRadius: 20
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.4)'
  }
};

const RecentCompanies = ({ data }) => {
  if (isEmpty(data)) return null;
  return (
    <React.Fragment>

      <table className="table table-hover" style={{fontSize: '16px'}}>
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Website</th>
            <th>City</th>
            <th>State</th>
            <th>Country</th>
            <th>Linked in</th>
            <th>Industry</th>
          </tr>
        </thead>
        <tbody>
          {data.map((company, index) => {
            return (
              <React.Fragment>
              <tr key={index} className="r-c-main">
                <td style={{paddingTop: '20px'}}>
                <LazyLoad>
                    <a href={`//${company.url}`} target="_blank" onClick={(e) => { e.stopPropagation() }} style={{ marginRight: 5, fontSize: 15, color: '#13135c', textDecoration: "none" }}>
                      <img src={`https://www.google.com/s2/favicons?domain=${company.url}`} style={{ marginRight: 5, width: 25, height: 25 }} />
                    </a>
                  </LazyLoad>
                  <Link to={`/company/${encodeforspace(company.company_name)}`}>{company.company_name}</Link></td>
                <td style={{paddingTop: '20px'}}>
                  <a href={'https://' + company.url} target="_blank">{company.url}</a>
                </td>
                <td style={{paddingTop: '20px'}}>{company.city}</td>
                <td style={{paddingTop: '20px'}}>{company.state}</td>
                <td style={{paddingTop: '20px'}}>{company.country}</td>
                <td style={{paddingTop: '20px'}}>{company.company_name && <a href={ company.linkedin_url} target="_blank">{company.company_name} LinkedIn</a>}</td>
                <td style={{paddingTop: '20px'}}>{company.industry}</td>
              </tr>
              <tr key={'bio_'+index}>
                <td style={{borderBottom: "1px solid", borderTop: "0px", padding: "5px 0px 30px 10px"}} colSpan={7}>
                <hr style={{margin: "0px 0px 5px 0px"}} />
                  {ReactHtmlParser(company.bio)}

                </td>
              </tr>
              </React.Fragment>
              
            )
          })}
        </tbody>
      </table>

    </React.Fragment>
  )
}


Modal.setAppElement('#root')

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
      tableData: []
    };
  }
  selectCompany = (company, id) => {
    this.props.history.push(`/company/${company}`);
  }

  
  getData = () => {
    console.log('hreere')
    Postman.getRecentlyAddedCompanies()
      .then(res => {
          this.setState({ tableData: res.data.data })
      })
  }

  componentDidMount() {
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    console.log('heree');
  }
 
  render() {
    const { totalCount, context } = this.props

    return (
      <div className="animated fadeIn" style={{ height: "100%" }}>
        <Helmet>
          <title>Growjo's Recently Added Companies</title>
          <meta name="description" content="Growjo's - Recently Added Companies" />
          <meta name="author" content="Growjo" />
        </Helmet>
        <Card className="custm-card " style={{ height: '100%', marginBottom: 0 }}>
          <CardHeader style={{ backgroundColor: 'white', paddingTop: 0 }}>
            <div className='row'>
              <div className='col-12 col-md-7'>
                <h2 style={{ fontSize: 28, margin: 0, marginTop: 10, fontWeight: 'bold' }}>Growjo's Recently Added Companies</h2>
              </div>
            
            </div>


          </CardHeader>
          <CardBody className="position-relative" style={{ paddingTop: '5px' }}>
            <div className='row'>
              <div className='col-12'>
                  <RecentCompanies data={this.state.tableData} />
              </div>
            </div>

          </CardBody>
        </Card>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.filter.data,
  isFilterOpened: state.filter.isOpened,
  totalCount: state.filter.totalCount,
  auth: state.auth
})
const mapDispatchToProps = dispatch => ({
  setFilterStatus: isOpened => dispatch({ type: SET_IS_FILTER_OPENED, payload: isOpened }),
  setFilter: filter => dispatch({ type: SET_FILTER, payload: filter }),
})

const ConnectedHome = connect(mapStateToProps, mapDispatchToProps)(Home)

class HomeWrapper extends React.Component {
  render() {
    return (
      <ConnectedHome context={this.context || {}} {...this.props} />
    )
  }
}
HomeWrapper.contextType = AppContext;
export default HomeWrapper;



// WEBPACK FOOTER //
// ./client/src/views/Home/RecentlyAdded.js